module.exports = __webpack_public_path__ + "img/PurposeAndNeed_03_goals.c05b0309.jpg";